/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Val_FlacInputs */

const en_val_flac = /** @type {(inputs: Val_FlacInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`FLAC`)
};

const es_val_flac = /** @type {(inputs: Val_FlacInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`FLAC`)
};

const fr_val_flac = /** @type {(inputs: Val_FlacInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`FLAC`)
};

const de_val_flac = /** @type {(inputs: Val_FlacInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`FLAC`)
};

const ja_val_flac = /** @type {(inputs: Val_FlacInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`FLAC`)
};

const zh_val_flac = /** @type {(inputs: Val_FlacInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`FLAC`)
};

const ar_val_flac = /** @type {(inputs: Val_FlacInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`FLAC`)
};

const id_val_flac = /** @type {(inputs: Val_FlacInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`FLAC`)
};

const it_val_flac = /** @type {(inputs: Val_FlacInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`FLAC`)
};

const ru_val_flac = /** @type {(inputs: Val_FlacInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`FLAC`)
};

const pt_val_flac = /** @type {(inputs: Val_FlacInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`FLAC`)
};

const ko_val_flac = /** @type {(inputs: Val_FlacInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`FLAC`)
};

/**
* | output |
* | --- |
* | "FLAC" |
*
* @param {Val_FlacInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const val_flac = /** @type {((inputs?: Val_FlacInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Val_FlacInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_val_flac(inputs)
	if (locale === "es") return es_val_flac(inputs)
	if (locale === "fr") return fr_val_flac(inputs)
	if (locale === "de") return de_val_flac(inputs)
	if (locale === "ja") return ja_val_flac(inputs)
	if (locale === "zh") return zh_val_flac(inputs)
	if (locale === "ar") return ar_val_flac(inputs)
	if (locale === "id") return id_val_flac(inputs)
	if (locale === "it") return it_val_flac(inputs)
	if (locale === "ru") return ru_val_flac(inputs)
	if (locale === "pt") return pt_val_flac(inputs)
	return ko_val_flac(inputs)
});